// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#surveyCreator {\n  height: calc(100vh - 63px - 81px);\n}\n.modal.show .modal-dialog.modal-full {\n  max-width: calc(100% - 10px);\n  width: calc(100% - 20px);\n  height: calc(100% - 20px);\n  margin: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
